export const APIS = {
  DEV: 'development',

  INSIGHTS: 'insights_api',
  INSIGHTS_JOBS: 'insight_job_api_start',

  CAMPAIGNS: 'campaigns_api',
  CAMPAIGN_JOBS: 'campaign_job_api_start',
  CAMPAIGN_DELIVERIES: 'campaign_deliveries_api',

  SMART_CLEAN_PMAP: 'smart_clean_api',
  SMART_CLEAN_P2MAP: 'smart_clean_api_p2map',

  ROBOTS: 'robots_api',
  ROBOTS_FAMILY_METADATA: 'robot_family_metadata_api',
  ROBOTS_SINGLE_FAMILY_METADATA: 'single_robot_family_metadata_api',

  NOTIFICATIONS: 'notifications_api',
  TIMELINE_NOTIFICATIONS: 'timeline_notifications_api',

  CONTENT: 'content_api',
  SINGLE_CONTENT: 'single_content_api',

  SINGLE_JOBS: 'single_jobs_api',
  FAILED_JOBS: 'get-failed-jobs',

  DRB: 'drb_api',
  HTA: 'high_traffic_area_api',
  KOZR: 'kozr_api',
  MAPS: 'maps_api',
  MESS_MAKERS: 'mess_makers_api',
  CLEANING_ESTIMATES: 'cleaning_estimates_api',
  RTP: 'qa_rtp_api',
  SURVEYS: 'surveys_api',
  RESPONSES: 'responses_api'
} as const;
